/*
 * Copyright (c) 2015 - 2022 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { loadingElement } from "./utils/loadingElement";
function fileBasename(path) {
  return path.replace(/\\/g, '/').replace(/.*\//, '');
}

/**
 * @param containerSelector
 * @property {string} autoUpload
 */
export function fileInputInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  var fileInputElements = container.querySelectorAll('.file-input');
  var _loop = function _loop() {
      var fileInput = fileInputElements[i];
      var hasAutoUpload = fileInput.dataset.autoUpload === 'true';
      var input = fileInput.querySelector('input[type="file"]');
      if (!hasAutoUpload) {
        input.addEventListener('change', function (e) {
          var files = e.target.files;
          if (!!files) {
            Array.prototype.forEach.call(files, function (file) {
              addFileToList(input, file, hasAutoUpload);
            });
          }
        });
        return {
          v: void 0
        };
      }
      var uploadRoute = input.dataset.uploadRoute;
      if (!uploadRoute) return {
        v: console.warn(adminConfig.messages.routeNotSpecified)
      };
      var containerId = fileInput.dataset.container;
      if (!containerId) return {
        v: console.warn(adminConfig.messages.containerIdNotSpecified)
      };
      var container = document.getElementById(containerId);
      if (!container) return {
        v: console.warn(adminConfig.messages.containerNotExist)
      };
      input.addEventListener('change', function (e) {
        fileUpload(fileInput, e.target.files);
      });
      function fileUpload(input, files) {
        if (!!files) {
          loadingElement.start(container);
          // console.log(files);
          var promises = [];
          Array.prototype.forEach.call(files, function (file) {
            // console.log(file);
            var formData = new FormData();
            formData.append('file', file);
            var headersObj = {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'multipart/form-data'
            };
            promises.push(httpRequest({
              url: uploadRoute,
              data: formData,
              headers: headersObj
            }));
          });
          // console.info(promises);
          axios.all(promises).then(axios.spread(function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            for (var _i = 0; _i < args.length; _i++) {
              if (args[_i] && args[_i].data) {
                // processRequestResponse(args[i].data);
                if (!args[_i].data.error) {
                  addFileToList(input, args[_i].data);
                  // console.warn(args[i].data);
                }
              }
            }
          }))["finally"](function () {
            loadingElement.finish(container);
          });
        }
      }

      /**
       * @param input
       * @param file
       * @param hasAutoUpload
       * @property {string} getPath
       * @property {string} deletePath
       */
      function addFileToList(input, file, hasAutoUpload) {
        if (hasAutoUpload === void 0) {
          hasAutoUpload = false;
        }
        var inputContainer = input.closest('.file-input');
        if (!inputContainer.querySelector('.file-list')) {
          // console.info('here')
          var fileListNode = document.createElement("div");
          fileListNode.classList.add('file-list');
          inputContainer.appendChild(fileListNode);
        }
        var fileList = inputContainer.querySelector('.file-list');
        var template;
        if (!hasAutoUpload) {
          if (!input.multiple) {
            fileList.innerHTML = "";
          }
          template = '<div class="file-item py-2"><span class="file-name">' + fileBasename(file.name) + '</span></div>';
        } else {
          template = '<div class="file-item">' + '<a href="' + file.getPath + '" class="file-name text-reset" target="_blank">' + fileBasename(file.path) + '</a>' + '<button type="button" class="file-input-remove-btn" data-delete-route="' + file.deletePath + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zM9 4v2h6V4H9z"/></svg></button>' + '</div>';
        }
        fileList.insertAdjacentHTML('beforeend', template);
      }
    },
    _ret;
  for (var i = 0; i < fileInputElements.length; i++) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
}